import { ButtonView, Locale, Plugin } from 'ckeditor5'

export default class TickListButtonPlugin extends Plugin {
  public static readonly pluginName = 'TickListButtonPlugin'

  init(): void {
    const editor = this.editor

    editor.ui.componentFactory.add('tick', (locale: Locale) => {
      const button = new ButtonView(locale)

      button.set({
        label: 'Tick',
        tooltip: true,
        withText: false,
        icon: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <path d="M3.6 4.5h7.9v1.4H3.6zM3.6 9.3h7.9v1.4H3.6zM3.6 14.1h7.9v1.4H3.6z"/>
  <path d="m13.8 5.8 1.2-1.2 1.6 1.6 2.8-2.8 1.2 1.2-4 4zM13.8 10.6l1.2-1.2 1.6 1.6 2.8-2.8 1.2 1.2-4 4zM13.8 15.4l1.2-1.2 1.6 1.6 2.8-2.8 1.2 1.2-4 4z"/>
</svg>
`,
      })

      this.listenTo(button, 'execute', () => {
        editor.model.change((writer) => {
          const text = writer.createText('✓ ')
          editor.model.insertContent(text)
        })
        editor.editing.view.focus()
      })

      return button
    })
  }
}
